export default {
  methods: {
    processCustomTemplate(incomingTemplate, data) {
      const re = /<%([^%>]+)?%>/g;
      let match;
      let cursor = 0;
      let result = "";
      while ((match = re.exec(incomingTemplate))) {
        result += incomingTemplate.slice(cursor, match.index);
        result += data[match[1]];
        cursor = match.index + match[0].length;
      }
      const endOfTemplate = incomingTemplate.substr(
        cursor,
        incomingTemplate.length - cursor
      );
      result += endOfTemplate;
      return result;
    },
  },
};
